__turbopack_context__.v({
  "body": "typography-module__S_AVxq__body",
  "bodyLarge": "typography-module__S_AVxq__bodyLarge",
  "bodyLg": "typography-module__S_AVxq__bodyLg",
  "bodyMd": "typography-module__S_AVxq__bodyMd",
  "bodySm": "typography-module__S_AVxq__bodySm",
  "bodySmall": "typography-module__S_AVxq__bodySmall",
  "bodyXl": "typography-module__S_AVxq__bodyXl",
  "buttonLg": "typography-module__S_AVxq__buttonLg",
  "buttonMd": "typography-module__S_AVxq__buttonMd",
  "buttonSm": "typography-module__S_AVxq__buttonSm",
  "buttonXl": "typography-module__S_AVxq__buttonXl",
  "caption": "typography-module__S_AVxq__caption",
  "displayLg": "typography-module__S_AVxq__displayLg",
  "displayMd": "typography-module__S_AVxq__displayMd",
  "displaySm": "typography-module__S_AVxq__displaySm",
  "displayXl": "typography-module__S_AVxq__displayXl",
  "displayXs": "typography-module__S_AVxq__displayXs",
  "eyebrow": "typography-module__S_AVxq__eyebrow",
  "eyebrowLg": "typography-module__S_AVxq__eyebrowLg",
  "footerNav": "typography-module__S_AVxq__footerNav",
  "h1": "typography-module__S_AVxq__h1",
  "h2": "typography-module__S_AVxq__h2",
  "h3": "typography-module__S_AVxq__h3",
  "h4": "typography-module__S_AVxq__h4",
  "h5": "typography-module__S_AVxq__h5",
  "h6": "typography-module__S_AVxq__h6",
  "labelXs": "typography-module__S_AVxq__labelXs",
  "large": "typography-module__S_AVxq__large",
  "lead": "typography-module__S_AVxq__lead",
  "muted": "typography-module__S_AVxq__muted",
  "p": "typography-module__S_AVxq__p",
  "small": "typography-module__S_AVxq__small",
  "stat": "typography-module__S_AVxq__stat",
  "subtitle": "typography-module__S_AVxq__subtitle",
  "tab": "typography-module__S_AVxq__tab",
  "tag": "typography-module__S_AVxq__tag",
});
